module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/455.aa566adb.png";